import { useState } from "react";

const useInput = (initialValue, props, format) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(null);

  return {
    value,
    props: {
      value,
      onChange: (event) => {
        setError(null);
        setValue(format ? format(event.target.value) : event.target.value);
      },
      error,
      ...props,
    },
    error: error,
    setValue: (newValue) => {
      setError(null);
      setValue(newValue);
    },
    setError: (err) => setError(err),
    resetError: () => setError(null),
    onChange: (value) => {
      setError(null);
      setValue(value);
    },
  };
};

export default useInput;
